//
// Utility Plugin for setting the configuration
//
import { pluginFactory } from './utils/plugins';
var BVConfigPlugin =
/*#__PURE__*/
pluginFactory();
export default BVConfigPlugin;


//////////////////
// WEBPACK FOOTER
// ./~/bootstrap-vue/esm/bv-config.js
// module id = odg0
// module chunks = 21